import mapping from "./mapping";
import config from "./config";

export default {
  component: () => import("./RcDemo.vue"),
  mapping,
  config
};
